import _ from 'lodash';
import QCFlagModel from '../models/QCFlagModel';
import BaseStore from './BaseStore';
import { computed } from 'mobx';

class QCFlagStore extends BaseStore {
  constructor(transportLayer) {
    super(QCFlagModel, transportLayer);
  }

  @computed get mappedItems() {
    return this.items.reduce((acc, item) => {
      acc[item.caption] = item;
      return acc;
    }, {});
  }

  getFlagByCaption(caption) {
    return this.mappedItems[caption.toString()];
  }

  getDescription(caption) {
    let flag = this.items.find(item => +item.caption === +caption);
    return !!flag ? flag.description : caption;
  }

  getProperFlag(flag) {
    flag = flag.toString();
    while (flag.length < 4) flag = '0' + flag;
    return flag.split('').map(item => +item);
  };

  getMaxFlag(flag) {
    const flags = this.getProperFlag(flag);
    const hqc = flags.shift();
    return !!hqc ? hqc : _.max(flags);
  }

  setHQCFlag(flag, hqc) {
    const flags = this.getProperFlag(flag);
    flags.shift();
    flags.unshift(hqc);
    return flags.join('');
  }
}

export default QCFlagStore;



// WEBPACK FOOTER //
// ./src/stores/QCFlagStore.js